<template>
  <InputComponent class="residential-fields-status" :label="label" v-bind="$attrs" v-on="$listeners">
    <Select v-model="comp" v-bind="$attrs" :items="items" />
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </InputComponent>
</template>

<script>
import { mapState } from 'vuex'
import { ValueComp } from '@/utils'
import { InputComponent } from 'vue-elder-input'
import { i18n } from '@/i18n'
import Select from '@/components/Select/Select'

const meta = {
  label: i18n.t('status'),
}

export { meta }
export default {
  props: {
    value: String,
    data: {
      type: Object,
      default: () => ({}),
    },

    saleType: String,
    isDisabled: {
      type: Function,
      default: () => false,
    },
    suffix: {
      type: Function,
      default: () => '',
    },
  },
  computed: {
    comp: ValueComp(),
    saleTypeComp() {
      return this.saleType || this.$path('sale.type', this.data)
    },
    label: () => meta.label,
    items() {
      return this.status.map(status => ({
        value: status,
        label: [this.$t(`residentialStatus:${this.saleTypeComp}.${status}`), this.suffix(status)]
          .filter(Boolean)
          .join(' '),
        disabled: this.isDisabled(status),
      }))
    },
    ...mapState({
      status(state) {
        switch (this.saleTypeComp) {
          case 'sale':
            return state.enums.ResidentialStatus.filter(
              item => !['rent', 'rented'].some(prohibited => item === prohibited),
            )
          case 'rent':
            return state.enums.ResidentialStatus.filter(
              item => !['sale', 'sold'].some(prohibited => item === prohibited),
            )
          default:
            return state.enums.ResidentialStatus
        }
      },
    }),
  },
  components: {
    InputComponent,
    Select,
  },
}
</script>

<style lang="scss">
.residential-fields-status {
  .elder-button {
    border: none;
    text-decoration: underline;
    &__label {
      padding: 2px 0.5rem;
    }
  }
}
</style>
